/**
 * Persistent storage for the devise_token_auth headers — the operator
 * console's, under the dashboard's own key so the two apps never share a
 * session on one browser.
 */

export interface AuthHeaders {
  'access-token': string;
  client: string;
  uid: string;
  expiry: string;
}

const STORAGE_KEY = 'kpi_dashboard.auth';

export function saveAuthHeaders(headers: AuthHeaders): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(headers));
}

/** null when nothing is stored, the JSON is malformed or a field is missing. */
export function loadAuthHeaders(): AuthHeaders | null {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;

  try {
    const parsed = JSON.parse(raw) as Partial<AuthHeaders>;
    if (
      typeof parsed['access-token'] === 'string' &&
      typeof parsed.client === 'string' &&
      typeof parsed.uid === 'string' &&
      typeof parsed.expiry === 'string'
    ) {
      return parsed as AuthHeaders;
    }
  } catch {
    // malformed JSON reads as no session
  }

  return null;
}

export function clearAuthHeaders(): void {
  localStorage.removeItem(STORAGE_KEY);
}
